<template>
    <div id="bloco-certificacao-territorio">
        <h2 class="titulo-bloco-certificacao-territorio">
            {{ $tc('certification.messages.territorial_certifications') }}
        </h2>
        <el-card shadow="never" :body-style="{ padding: '16px' }">
            <el-checkbox
                class="certificacao-territorio-checkbox"
                v-for="(cert, index) in dadosCertificacaoTerritorio"
                :key="index"
                :label="cert.tipoCertificacaoNome"
                v-model="cert.status"
                @change="openModal(cert)"
            />
        </el-card>

        <el-dialog
            :visible.sync="modalConfirmacao"
            :title="
                this.certificadoSelecionado.status
                    ? $t('certification.messages.mark_as_certified')
                    : $t('certification.messages.unmark_as_certified')
            "
            :destroy-on-close="true"
            :show-close="false"
            width="30%"
            append-to-body
            :before-close="cancelAction"
        >
            <footer style="display: flex; justify-content: space-between">
                <el-button @click="cancelAction()" size="mini">
                    {{ $t('certification.words.cancel') }}
                </el-button>
                <el-button type="primary" @click="confirmAction()" size="mini">
                    {{ $t('certification.words.confirm') }}
                </el-button>
            </footer>
        </el-dialog>
    </div>
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import { mapActions } from 'vuex';

export default {
    name: 'BlocoCertificacaoTerritorio',
    components: {},
    props: {
        dadosCertificacao: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dadosCertificacaoTerritorio:
                this.dadosCertificacao.certificacaoTerritorioResultado,
            modalConfirmacao: false,
            certificadoSelecionado: Object
        };
    },
    watch: {
        dadosCertificacao(newVal) {
            this.dadosCertificacaoTerritorio =
                newVal.certificacaoTerritorioResultado;
            this.mountObject();
        }
    },
    methods: {
        ...mapActions('certification', ['setCertificado']),
        mountObject() {
            this.verifyCertifications(
                this.dadosCertificacao.certificacaoStatus
            );

            this.dadosCertificacao.certificacaoTerritorioResultado.forEach(
                certificado => {
                    let certificadoEncontrado =
                        this.dadosCertificacao.certificacaoStatus.find(
                            certificadoStatus =>
                                certificado.tipoCertificacaoCodigo.toUpperCase() ===
                                certificadoStatus.codigo.toUpperCase()
                        );

                    if (certificadoEncontrado) {
                        Object.assign(certificado, certificadoEncontrado);
                    }
                }
            );
        },
        openModal(cert) {
            this.certificadoSelecionado = cert;
            this.modalConfirmacao = true;
        },
        cancelAction() {
            this.certificadoSelecionado.status =
                !this.certificadoSelecionado.status;
            this.modalConfirmacao = false;
        },
        async confirmAction() {
            await TerritorioService.atualizarCertificacaoTerritorio(
                this.dadosCertificacao?.dadosTerritorio[0].idTerritorio,
                this.certificadoSelecionado.id,
                this.certificadoSelecionado.status
            ).finally(() => {
                let temCertificado = false;
                this.dadosCertificacaoTerritorio.map(certificado => {
                    if (certificado.status === true) {
                        temCertificado = true;
                    }
                });
                this.setCertificado(temCertificado);
            });
            this.modalConfirmacao = false;
        },
        verifyCertifications(certificacaoStatus) {
            certificacaoStatus.some(certificado => {
                if (certificado.status === true) {
                    this.setCertificado(true);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-certificacao-territorio {
    .titulo-bloco-certificacao-territorio {
        font-weight: bold;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }
    .certificacao-territorio-checkbox {
        font-size: 14px;
        font-weight: bold;
        color: var(--primary);
        margin-right: 20px !important;
    }
}
</style>
